export default __webpack_public_path__ + "static/media/sliderIndicatorLight.5b3025d4.svg";